<template>
    <SignaloDialog
        :open="true"
        :title="$t('common.scanCode')"
        :icon="'mdi-qrcode-scan'"
        :hideActions="true"
    >
        <template #body>
            <qrcode-stream
                @detect="(val) => onDetect(val)"
                :formats="['qr_code', 'code_128', 'codabar', 'ean_13', 'ean_8']"
            ></qrcode-stream>
        </template>
    </SignaloDialog>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import * as HELPERS_STORE from 'signalo-vue-helpers-store';
export default {
    setup() {
        const helpersStore = HELPERS_STORE.default();
        return { helpersStore };
    },
    components: {
        QrcodeStream,
    },
    methods: {
        onDetect(val) {
            this.helpersStore.snackbar(this.$t('common.codeRecognized'), 'success');
            Array.from(val?.[0]?.rawValue).forEach((k) => {
                document.dispatchEvent(new KeyboardEvent('keyup', { key: k }));
            });
            setTimeout(() => {
                this.$emit('close');
            }, 0)
        },
    },
};
</script>
